import createRoute      from '@widesk-ui/tools/createRoute';
import PartnershipModel from '@models/shop/PartnershipModel';

export default createRoute.splitView('/partnerships', 'shop', 'PartnershipSplitView', PartnershipModel.localize('plural'));
